<template>
  <div> 
	<!-- <CCardHeader>
	<CButton color="primary" class="px-4" @click="add()">Add module</CButton>
	</CCardHeader> -->
	 <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="getShuffledModulesData()"
          hover
          striped
          bordered
          small
          fixed
          caption="Module list"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from './Manage_module.vue'
import axios from "axios";
// import usersData from '../manage_modules/UsersData'

export default {
  name: 'Manage_users',
  components: { CTableWrapper },
  data() {
	  return {
         isLoading: false
	  }
  },
  mounted() {
    this.isLoading = true;
  },
  methods: {
    getShuffledModulesData () {
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var token=localStorage.getItem("auth");
		var requestInfo = {		
		Token:token,
		Session_User_Id:Session_User_Id,
		};
		var data = JSON.stringify(requestInfo);							
			var config = {
			  method: 'post',
			  url: apiURL+'ManageModule/GetModuleList',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
		var self =this;
		var usersData=[];
		axios(config)
		.then((result) => {	
			setTimeout(() => {

				this.isLoading = false;		
			}, 2000)
			if(result.data.status_code==200){
				var obj=result.data.response;
				var totrow=obj.length;
				for(var i=0;i<totrow;i++){					
					var row={ Module_Id: obj[i].Module_Id,ModuleName: obj[i].ModuleName, status: obj[i].Status, action: 'Edit'};
					usersData.push(row);					
				}								
			}else{								
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
		})
		.catch((error) => {				
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
		return usersData;
		
    },
	shuffleArray (array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }
      return array
    },
	add(){
		//console.log('add');
		this.$router.push({path:'add_modules'})
	}
  }
}
</script>
